<template>
  <div class="z-body">
    <header class="z-header">
      <div>
        <router-link to="/my"><img src="../../assets/sysbars/left.png" /></router-link>
      </div>
      <div>{{$t('修改支付密码')}}</div>
      <div></div>
    </header>
    <section>
      <div class="inputBox" v-if="s==1">
        <div style="width: 10%;">
          <img class="z-icon" src="../../assets/icon/register/password2.png">
        </div>
        <div style="width: 70%;">
          <input type="password" v-model="opaypwd" style="width: 100%;outline:none;font-size: 16px"
            :placeholder="$t('原支付密码')">
        </div>
        <div style="width: 30%;text-align: right">
          <div class="z-icon"></div>
        </div>
      </div>
      <div class="inputBox">
        <div style="width: 10%;">
          <img class="z-icon" src="../../assets/icon/register/password2.png">
        </div>
        <div style="width: 60%;">
          <input type="password" v-model="paypwd" style="width: 100%;outline:none;font-size: 16px"
            :placeholder="$t('新支付密码')">
        </div>
        <div style="width: 30%;text-align: right">
          <div class="z-icon"></div>
        </div>
      </div>
      <div class="inputBox">
        <div style="width: 10%;">
          <img class="z-icon" src="../../assets/icon/register/password2.png">
        </div>
        <div style="width: 60%;">
          <input type="password" v-model="repaypwd" style="outline:none;font-size: 16px" :placeholder="$t('确认新支付密码')">
        </div>
        <div style="width: 30%;text-align: right">
          <div class="z-icon"></div>
        </div>
      </div>
    </section>
    <!-- 	<section>
	  <div class="inputBox">
		<div style="width: 10%;">
		  <img class="z-icon" src="../../assets/icon/register/email.png">
		</div>
		<div style="width: 60%;">
		  <input v-model="mine.email" style="outline:none;font-size: 16px" :placeholder="$t('邮箱')" readonly="">
		</div>
		<div style="width: 30%;text-align: right">
		  <div class="z-icon" ></div>
		</div>
	  </div>
	</section> -->
    <!-- <section>
	  <div class="inputBox">
		<div style="width: 10%;">
		  <img class="z-icon" src="../../assets/sdkj/mobile.png">
		</div>
		<div style="width: 60%;">
		  <input v-model="mine.mobile" style="outline:none;font-size: 16px" :placeholder="$t('手机号')" readonly="">
		</div>
		<div style="width: 30%;text-align: right">
		  <div class="z-icon" ></div>
		</div>
	  </div>
	</section> -->
    <!-- 	<section>
	  <div style="padding-right: 0px" class="inputBox" >
		<div style="width: 10%;">
		  <img class="z-icon" src="../../assets/icon/register/smscode.png">
		</div>
		<div style="border-right: 1px solid black;width: 60%;height: 100%;line-height: 60px">
		  <input v-model="code" style="outline:none;font-size: 16px" :placeholder="$t('验证码')">
		</div>
		<div v-if="!sendOnOff" @click="getEmailCode" style="height: 100%;line-height: 60px;width: 30%;text-align: center;font-size: 15px">
		  {{$t('获取验证码')}}
		</div>
		<div v-if="sendOnOff" style="height: 100%;line-height: 60px;width: 30%;text-align: center;font-size: 15px">
		  {{coutDown}}
		</div>
	  </div>
	</section> -->
    <section style="text-align: center">
      <div @click="doPost" class="common-btn">{{$t('提交')}}</div>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'paypwd',
    data() {
      return {
        mine: {
          mobile: '',
          email: '',
        },
        opaypwd: "",
        paypwd: "",
        repaypwd: "",
        phoneNumber: "",
        code: "",
        sendOnOff: false,
        coutDown: 60,
        s:1,
      }
    },
    mounted() {

    },
    created() {
      this.doInit();
      this.s = this.$route.query.s?this.$route.query.s:1;
    },
    methods: {
      doInit: function() {
        //会员信息
        this.post('api/users/center', {}).then((res) => {
          if (res.code == 0) {
            this.mine = res.data
          } else {
            this.$store.commit('layer', res.msg)
          }
        })
      },
      // 邮箱验证码
      getEmailCode: function() {
        let _this = this;
        if (this.mine.email == "") {
          this.$store.commit('layer', this.$t('请输入') + this.$t('邮箱'))
        } else {
          this.post('api/index/sendEmailCode', {
            email: this.mine.email,
            cateid: 7
          }).then((res) => {

            if (res.code == 0) {
              _this.sendOnOff = true
              let itmer = setInterval(function() {
                if (_this.coutDown == 0) {
                  clearInterval(itmer)
                  _this.coutDown = 60
                  _this.sendOnOff = false
                } else {
                  _this.coutDown = _this.coutDown - 1
                }
              }, 1000)
            }
            this.$store.commit('layer', res.msg)
          })
        }
      },
      // 短信验证码
      getSmsCode: function() {
        let _this = this;
        if (this.mine.mobile == "") {
          this.$store.commit('layer', this.$t('请输入') + this.$t('手机号'))
        } else {
          this.post('api/sms/userSend', {
            mobile: this.mine.mobile,
            cateid: 7
          }).then((res) => {

            if (res.code == 0) {
              _this.sendOnOff = true
              let itmer = setInterval(function() {
                if (_this.coutDown == 0) {
                  clearInterval(itmer)
                  _this.coutDown = 60
                  _this.sendOnOff = false
                } else {
                  _this.coutDown = _this.coutDown - 1
                }
              }, 1000)
            }
            this.$store.commit('layer', res.msg)
          })
        }
      },
      // 提交
      doPost: function() {
        let _this = this
        if(this.s==1 && this.opaypwd == ""){
           this.$store.commit('layer', this.$t('旧密码未填写'))
        }
        if ( this.paypwd == "" || this.repaypwd == "") {
          this.$store.commit('layer', this.$t('部分信息未填写'))
        } else if (this.paypwd !== this.repaypwd) {
          this.$store.commit('layer', this.$t('两组密码不相同'))
        } else {
          this.post('api/users/SetPayPwd', {
            newpwd: this.paypwd,
            opaypwd: this.opaypwd,
          }).then((res) => {
            this.$store.commit('layer', res.msg)
            if (res.code == 0) {
              _this.jump('/my');
            }
          })
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .inputBox {
    background-color: #424355;
    color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    padding: 0 30px 0 30px;
    margin-bottom: 2px;
    border-bottom: 1px solid #28293D;
  }
</style>



// WEBPACK FOOTER //
// src/pages/my/paypwd.vue